import { render, staticRenderFns } from "./OrderSettings.vue?vue&type=template&id=385eb3a9"
import script from "./OrderSettings.vue?vue&type=script&lang=js"
export * from "./OrderSettings.vue?vue&type=script&lang=js"
import style0 from "./OrderSettings.vue?vue&type=style&index=0&id=385eb3a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/i18n/i18n-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fsean%2Fprojects%2Fezmeals%2Fezmeals-order-ui%2Fsrc%2Fcomponents%2FOrderSettings.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./OrderSettings.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports